export function isAllNumbers(strings) {
    for (let i = 0; i < strings.length; i++) {
        if (isNaN(strings[i])) {
            return false;
        }
    }
    return true;
}
